/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react';
import { nanoid } from 'nanoid';
import { FormAddPlayer } from '../';
import { Utils, Teams } from '../../../../utils/api';
import { AdBody, AdFooter, AdBodyTitle } from '../../styles';
import { ARMcontext } from '../../../../utils/context/context';
import { Loader, LargeButton, ExpandedButton } from '../../../../components';
import { TYPES_INVITATIONS, SPONSOR_SELECTED_DEFAULT, INVITE_SELECTED_DEFAULT } from '../../../../utils/constants/defaultSponsor';

/**
 * individually invite players view
 *
 * @param param.membershipsYearly - Number of sponsor subscription available
 * @param param.membershipsYearlyCount - number of yeraly subscriptions available
 * @param param.membershipsYearlyTotal - number of total subscriptions (with subscriptions that have been canceled to players)
 * @param param.changeMembershipsYearly - modify the membershipsYearly
 * @param param.handleView - handles the visibility of the add players modal and makes the request to update the manage players table
 * @returns returns the view with the form to individually load each player and send the invitation
 */
export default ({
  membershipsYearly,
  membershipsYearlyCount,
  membershipsYearlyTotal,
  changeMembershipsYearly,
  handleView,
}: {
  membershipsYearly: any;
  membershipsYearlyCount: any;
  membershipsYearlyTotal: number;
  changeMembershipsYearly: any;
  handleView: Function;
}) => {
  const UTILS = new Utils();
  const TEAM = new Teams();
  const [validate, setValidate] = useState<number>(0);
  const [error, setError] = useState<Array<any>>([]);
  const { HandleToastMessage } = useContext(ARMcontext);
  const [buttonTimer, useButtonTimer] = useState<any>(true);
  const [firstUploadMemberships, setFirstUploadMemberships] = useState<boolean>(true);
  const [invitations, setInvitations] = useState<Array<object | any>>([{
    firstName: '', lastName: '', email: '', team: [], sponsor: {}, block: [], id: nanoid()
  }]);

  useEffect(() => {
    if (firstUploadMemberships && membershipsYearly) {
      let avaibleMembership = membershipsYearly?.find((item: any) => !item.selected);
      setInvitations(prev => {
        return [{ ...prev[0], sponsor: !avaibleMembership ? INVITE_SELECTED_DEFAULT : SPONSOR_SELECTED_DEFAULT }];
      })
      setFirstUploadMemberships(false);
    }
  }, [membershipsYearly])

  useEffect(() => {
    if (validate !== 0 && error.length === 0) {
      HandleSubmit();
    }
  }, [error]);

  function OnClose(id) {
    UTILS.Later(100).then(() => setInvitations(invitations.filter(elem => elem.id !== id)));
  }

  function AddPlayer() {
    let avaibleMembership = membershipsYearly.find((item: any) => !item.selected);
    setInvitations(prev => [...prev, {
      firstName: '',
      lastName: '',
      email: '',
      team: [],
      sponsor: !avaibleMembership ? INVITE_SELECTED_DEFAULT : SPONSOR_SELECTED_DEFAULT,
      id: nanoid()
    }]);
  }

  function StartValidations(): void {
    setValidate(UTILS.GetRandomInt(1, 20));
  }

  async function HandleSubmit(): Promise<void> {
    setValidate(0);
    useButtonTimer(false);
    const send = invitations.map(el => {
      const teams = el.team?.map(team => team._id)?.filter(team => team !== undefined);
      let sendBlock;
      if (el.sponsor.value !== TYPES_INVITATIONS.SPONSOR_PLAYER) {
        delete el.block;
      } else {
        sendBlock = el.selectedBlock?.blockId;
      }

      const build = {
        firstName: el.firstName,
        lastName: el.lastName,
        email: el.email,
        requestType: el.sponsor.type,
        team: teams,
        block: sendBlock,
      };
      return build;
    });
    const result = await TEAM.InviteMultiplePlayersToAteam(send);
    if (result.status) {
      if (result.data.invitations.length) {
        HandleToastMessage('Invitation sent', true, 2500, 'success');
        handleView(false, true);
      } else {
        HandleToastMessage('User already invited', true, 2000, 'error');
      }
      useButtonTimer(true);
    } else {
      HandleToastMessage(result.data?.message || 'Invitation not sent', true, 3000, 'error');
      useButtonTimer(true);
    }
  }

  return (
    <>
      <AdBody>
        <div>
          <AdBodyTitle>Players</AdBodyTitle>
        </div>
        {invitations.map((el, index) => (
          <FormAddPlayer
            index={index}
            element={el}
            OnClose={OnClose}
            setError={setError}
            validate={validate}
            key={`CAP-${el.id}`}
            length={invitations.length}
            setInvitations={setInvitations}
            membershipsYearly={membershipsYearly}
            membershipsYearlyCount={membershipsYearlyCount}
            membershipsYearlyTotal={membershipsYearlyTotal}
            changeMembershipsYearly={changeMembershipsYearly}
            handleToastMessage={HandleToastMessage}
          />
        ))}
        <ExpandedButton text="ADD ANOTHER PLAYER" icon="plus" callback={AddPlayer} dataCy="addPlayers-extra-invitation" />
      </AdBody>
      <AdFooter>
        <LargeButton
          lMargin="0"
          title="CANCEL"
          rMargin="0 40px"
          rColor="#ffffff"
          lColor="#ffffff"
          fColor="#5D6C76"
          bColor="#F0F0F0"
          xMargin="0 10px 0 0"
          dataCy="addPlayers-cancel"
          callback={() => handleView(false)}
        />

        {buttonTimer ? (
          <LargeButton
            icon="done"
            rColor="#007AFF"
            lColor="#006BE1"
            title="SEND INVITE"
            callback={StartValidations}
            dataCy="addPlayers-submit"
          />
        ) : (
          <Loader width="186px" />
        )}
      </AdFooter>
    </>
  );
};
